import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BudgetRoster.html?raw';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import lang from 'dojo/_base/lang';
import { uiFrameTypes } from "../../moreCore/UI/Container/uiFrameTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import "../../moreCore/UI/SelectBox/SelectBox";
import "../../moreCore/UI/SearchSelect/SearchSelect";
import { StringHelpers, TranslationHelpers } from "../../more/Helpers";
import BudgetTable from './BudgetTable';
import { FilterPanelTypes, FilterPanelWidget } from "../../moreCore/_loadingHelpers/Filterpanel";
import "../../moreCore/UI/FilterPanel/FilterPanel";
import BudgetSummaryTable from './BudgetSummaryTable';


interface Location extends more.EntityAPIResult {
    
        projectID: string,
        config?: any 
}

interface RosterConfig {
    locationID: string,
    periodID: string,
    distributionChannelID: string
}

type ContentModes = "budget" | "summary";
class BudgetRoster extends compose(_uiFrameMixin) {
    templateString: any = template;

    private rosterContent: HTMLElement;

    private inputDistributionChannel: MdsLax<InstanceType<typeof SelectBox>>;
    private filterPanel: MdsLax<InstanceType<typeof FilterPanelWidget>>;

    //private _selectedLocationID: string;
    //private _selectedPeriodID: string;
    private _rosterConfig: Partial<RosterConfig> & { filterPanelData?: any, targetContent?: ContentModes};
    //private _previousRosterConfig: RosterConfig;

    private _hiddenNode: HTMLElement;
    private setupContent: HTMLElement;
    //private setupDlg: GenericDialog;

    private _budgetTables: Record<string, { widget: MdsLax<InstanceType<typeof BudgetTable>>, expanded: boolean }>;

    private btnRoster: MdsLax<InstanceType<typeof Button>>;
    private btnSummaryTable: MdsLax<InstanceType<typeof Button>>;

    private _checkUrlParams() {
        let id = this.getUrlParameterValue("sid");
        let preConfig: RosterConfig;
        
        if (id) {
            let sessions = this._loadSessionsFromStorage();
            let session = sessions[id];
            if (session) {
                preConfig = session;
            }
        }

        if (preConfig) {
            this._rosterConfig = preConfig;
            this._loadFilterpanelOptions();
        }
        else this.removeUrlParameter("sid");
    }

    private _loadSessionsFromStorage(): Record<string, any> {
        let strValue = localStorage.getItem("ego_budgetRosterSessions");
        let sessions: Record<string, RosterConfig>;
        try {
            sessions = JSON.parse(strValue);
            if (sessions) return sessions;
        } catch (ex) {

        }
        return {};
    }

    private _saveSessionToStorage(config: any, id?: string): string | false {
        let sessions = this._loadSessionsFromStorage();
        if (!sessions) return false;
        if (!id) id = StringHelpers.randomID(10);
        sessions[id] = config;

        try {
            let strValue = JSON.stringify(sessions);
            localStorage.setItem("ego_budgetRosterSessions", strValue);
            return id;
        } catch (ex) {

        }

        return false;
    }

    setup(openAs?: uiFrameTypes.DisplayMode, title?: string, preConfig?: RosterConfig) {
        //this._selectedLocationID = locationID;
        //this._selectedPeriodID = periodID;

        if (preConfig) this._rosterConfig = lang.clone(preConfig);

        if (openAs) this.show(openAs, title);
        else if (this.isActive) {
            this._loadRoster();
        }
    }

    protected onShow() {
        this._checkUrlParams();


        if (this._rosterConfig) {
            this._loadRoster();
        } else {
            this._loadFilterpanelOptions();                
        }
    }

    //private _setupFilterpanel() {
    //    let filterPanel = this.filterPanel;

    //    //let dlg = new GenericDialog();

    //    //dlg.setup({
    //    //    header: "BudgetCalculationRoster_Header__SetupDlg",
    //    //    content: this.setupContent,
    //    //    buttonPreset: "okcancel",
    //    //    callback: lang.hitch(this, this._onSetupCallback, filterPanel),
    //    //    keepOpen: true,
    //    //    distinctiveNoCallback: lang.hitch(this, this._onAbortSetup),
    //    //    size: "smaller"
    //    //});

    //    //dlg.disableButton("ok");

    //    //this.setupDlg = dlg;

    //    this._loadFilterpanelOptions();
    //}

    private _loadFilterpanelOptions() {
        let data = {};
        this.StandbyStart(this.setupContent);
        this.RequestManager.callfunction("Webtool_API_BudgetCalculationRoster__GetFilterPanelConfig",
            data,
            lang.hitch(this, this._onLoadFilterPanelOptions, true),
            lang.hitch(this, this._onLoadFilterPanelOptions, false),
        );

        this.inputDistributionChannel.setBlankOption(true, true);
    }

    private _onLoadFilterPanelOptions(success: boolean, response) {
        this.StandbyStop();
        if (success === true) {
            let config = response as FilterPanelTypes.PanelConfig;
            this.filterPanel.setConfig(config);
        } else {
            let error = response as more.requestErrorMessage;
            this.showToast({
                title: "error loading configuration",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }

    }

    private _onChange_SetupFilterpanel() {
        let filterPanel = this.filterPanel;
        
        let locationID = filterPanel.getFilterOptionValue("event_city") as string; // event_city gibts nur bei DK. falls das mal jemand anders braucht: viel Spass beim Herumeiern mit Ersatzparametern....
        let seasonID = filterPanel.getFilterOptionValue("period") as string;


        if (locationID && seasonID && filterPanel.valid) {
            this.inputDistributionChannel.addAdditionalRequestParameter("locationID", locationID);
            this.inputDistributionChannel.addAdditionalRequestParameter("periodID", seasonID);

            this._rosterConfig = {
                distributionChannelID: null,
                locationID: locationID,
                periodID: seasonID
            };
            
            this.inputDistributionChannel.loadListValues(null);
            this.inputDistributionChannel.setReadonly(false);
        } else {
            this._rosterConfig = null;
            this.inputDistributionChannel.setValue(null);
            this.inputDistributionChannel.setReadonly(true);
        }

        this.btnRoster.setReadonly(!filterPanel.valid);
    }

    private _onChange_DistributionChannel() {
        let val = this.inputDistributionChannel.getValue();
        if (this._rosterConfig) {
            this._rosterConfig.distributionChannelID = val;
            //this.enableButton("ok", !!val);
            //this.btnRoster.setReadonly(!val);
            //this.btnSummaryTable.setReadonly(!val);
        }
    }

    private _onClick_OpenRoster(evt: PointerEvent) {
        this._submitFilterpanelParams("budget");
    }

    private _onClick_OpenSummary(evt?: PointerEvent) {
        this._submitFilterpanelParams("summary");
    }

    private _onCloseRoster(result) {
        this.UiModder.domConstruct.place(this.rosterContent, this._hiddenNode);
        this._rosterDlg = null;
        this.removeUrlParameter("sid");
    }

    reload() {
       
        this._loadRoster();
    }
    private _submitFilterpanelParams(target: ContentModes) {
        //this.UiModder.domConstruct.place(this.setupContent, this._hiddenNode);
        let filterPanel = this.filterPanel;
        let filterpanelData = filterPanel.getData();

        if (!this._rosterConfig) {
            this._rosterConfig = {

            };
        }

        this._rosterConfig.filterPanelData = filterpanelData;
        this._rosterConfig.targetContent = target;


        if (this.currentDisplayMode == "dlg") {
            this._uiFrameDlg.setSize("fullsize");
        }

        switch (this._rosterConfig.targetContent) {
            case "budget":
                this._loadRoster();
                break;

            case "summary":
                this._openSummaryTable();
                break;
        }

        let sessionId = this._saveSessionToStorage(this._rosterConfig);
        if (sessionId != false) {
            this.setUrlParameter("sid", sessionId);
        }

        //this.setupDlg.close();
    }

    private _loadRoster() {

        if (this._rosterDlg) {
            this.StandbyStart(this.rosterContent);
        } else {
            this.StandbyStart();
        }

        this.RequestManager.callfunction("Webtool_API_BudgetCalculationRoster__LoadRosterConfigs",
            this._rosterConfig,
            lang.hitch(this, this._onLoadRosterResponse, true),
            lang.hitch(this, this._onLoadRosterResponse, false),
        );
    }
    private _originalTitle: string;
    
    private _onLoadRosterResponse(success: boolean, response) {

        this.StandbyStop();

        if (success === true) {
            this._openRoster(response); 
        } else {
            let error = response as more.requestErrorMessage;
            this.showToast({
                title: "error loading configuration",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    private _rosterDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private _openRoster(rosterConfig: {
        locationID: string,
        periodID: string,
        title: string,
        configs: Array<BudgetTypes.BudgetTableConfiguration>
    }) {
        if (rosterConfig.configs.length == 0) {
            this.showToast({
                title: "BudgetCalculationRoster_NoResults",
                //message: error.Message,
                //iconClass: toasterIcons.error
            });
        } else {
            let dlg: MdsLax<InstanceType<typeof GenericDialog>> = this._rosterDlg;
            if (!this._rosterDlg) {
                dlg = new GenericDialog();
                this._rosterDlg = dlg;
            }

            dlg.setup({
                size: "fullsize",
                content: this.rosterContent,
                callback: lang.hitch(this, this._onCloseRoster),
                //distinctiveNoCallback: lang.hitch(this, this._onCloseRoster),
                buttonPreset: "close",
                header: "BudgetCalculationRoster_MainTitle",
                additionalButtons: [{
                    callback: lang.hitch(this, this.reload),
                    internalName: "reload",
                    label: "General_Reload",
                    iconClass: "fas fa-sync",
                    bCloseOnClick: false,
                    position: "left first"
                }, {
                    internalName: "expandAll",
                    label: "General_Label__ExpandAll",
                    callback: lang.hitch(this, this.expandAll, true),
                    iconClass: "fas fa-angle-double-down",
                    bCloseOnClick: false,
                    position: "left first"
                }, {
                    internalName: "collapseAll",
                    label: "General_Label__CollapseAll",
                    callback: lang.hitch(this, this.expandAll, false),
                    iconClass: "fas fa-angle-double-up",
                    bCloseOnClick: false,
                    position: "left first"
                    }, {
                    internalName: "summary",
                    label: "BudgetCalculationRoster_DisplaySummary",
                    callback: lang.hitch(this, this._openSummaryTable),
                    bCloseOnClick: false,
                    position: "last",
                    styleClass: "primary",
                    iconClass: "fas fa-table"
                    }
                ],
                closeOnEnter: false,
                closeOnEscape: false,
            });

            if (!this._originalTitle && this.title) this._originalTitle = TranslationHelpers.tryTranslate(this.title);
            if (rosterConfig.title) dlg._setHeaderAttr(rosterConfig.title + " - " + this._originalTitle);
            this._drawRoster(rosterConfig.configs);

        }
    }


    private _openSummaryTable() {
        let filterpanelData = this._rosterConfig.filterPanelData;
        if (filterpanelData) {

            let summaryTable = new BudgetSummaryTable();
            summaryTable.show("dlg", "BudgetCalculationRoster_Label__SummaryTable");

            summaryTable.setup(this._rosterConfig); 
        }

    }
    private _drawRoster(data: Array<BudgetTypes.BudgetTableConfiguration>) {
        this.UiModder.domConstruct.empty(this.rosterContent);
        let previousRec = this._budgetTables;
        this._budgetTables = {};
        for (let config of data) {

            let section = this.UiModder.domConstruct.create("div", {
                className: "marginTop"
            }, this.rosterContent);

            //let expander = new ExpandableSection();
            //expander.placeAt(section);
            
            // Reihenfolge wichtig fürs erste Status-Emit...

            let table = new BudgetTable();

            let previous = previousRec[config.projectID];

            this._budgetTables[config.projectID] = {
                expanded: previous ? previous.expanded : false,
                widget: table
            };
            let rec = this._budgetTables[config.projectID];

            table.on("expanded", lang.hitch(this, function (rec, state: boolean) { rec.expanded = state; }, rec));

            table.show("expander", config.title, section, previous?.expanded === true);

            

            //expander.setup(table.domNode, config.title);

            //config.title = null;
            table.setup(config);

            table.on("status", lang.hitch(this, this._onChange_BudgetTableStatus));

        }

        this.enableButton("summary");
    }

    private _onChange_BudgetTableStatus(status: BudgetTypes.BudgetTableStatus) {

    }

    private expandAll(bExpand: boolean = true) {
        for (let key in this._budgetTables) {
            let rec = this._budgetTables[key];
            rec.widget.expand(bExpand);
        }
    }

  
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this._budgetTables = {};
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(BudgetRoster);